<template>
	<div class="import">
		<ul>
			<li>Upload multiple files</li>
			<li>Click a button to upload</li>
			<li>Show the list of uploaded URLs</li>
		</ul>
		<UploadCard></UploadCard>
	</div>
</template>

<script>
import UploadCard from './upload/UploadCard'

export default {
	name: 'upload-questionnaire',

	components: {
		UploadCard
	}
}
</script>
<style lang="scss" scoped>
.import {
	padding: 10px;
}
</style>
